export enum FundingInquiryType {
  ROLLING_FUNDING = 'rolling_funding',
}

export const FUNDING_INQUIRY_CAPITAL_USAGE_VALUES = [
  'inventory',
  'growth_marketing',
  'expenses',
  'retail_expansion',
  'new_product_launch',
  'other',
] as const;

export const CAPITAL_USAGE_MAPPING: Record<FundingInquiryCapitalUsage, string> =
  {
    inventory: 'Inventory',
    growth_marketing: 'Growth/Marketing',
    expenses: 'Expenses',
    retail_expansion: 'Retail expansion',
    new_product_launch: 'New product launch',
    other: 'Other',
  };

export const CAPITAL_USAGE_REVERSE_MAPPING = Object.fromEntries(
  Object.entries(CAPITAL_USAGE_MAPPING).map(([key, value]) => [value, key]),
) as Record<
  (typeof CAPITAL_USAGE_MAPPING)[FundingInquiryCapitalUsage],
  FundingInquiryCapitalUsage
>;

export type FundingInquiryCapitalUsage =
  (typeof FUNDING_INQUIRY_CAPITAL_USAGE_VALUES)[number];

export interface FundingInquiryCapitalNeed {
  date: string;
  amount: number;
}

export interface CreateRollingFundingInquiryPayload {
  fundingAmount: number;
  isOngoingNeed: boolean;
  capitalNeeds?: FundingInquiryCapitalNeed[];
  oneTimeNeedDate?: string;
  capitalUsage?: FundingInquiryCapitalUsage[];
}

export interface RollingFundingInquiry {
  fundingAmount: number;
  isOngoingNeed: boolean;
  capitalNeeds?: FundingInquiryCapitalNeed[];
  oneTimeNeedDate?: string;
  capitalUsage?: FundingInquiryCapitalUsage[];
  businessId: number;
  submittedAt: string;
  validUntil: string;
}
